import { render, staticRenderFns } from "./edite-country.vue?vue&type=template&id=b5dbccc2&scoped=true"
import script from "./edite-country.vue?vue&type=script&lang=js"
export * from "./edite-country.vue?vue&type=script&lang=js"
import style0 from "./edite-country.vue?vue&type=style&index=0&id=b5dbccc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5dbccc2",
  null
  
)

export default component.exports